import {
  HashRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import Detail from './public/jobs/components/detail/detail';
import Job from './public/jobs/job';
import Subscribe from './public/jobs/subscribe';
import CVUpgrade from './public/jobs/cv-upgrade';
import AtsCheck from './public/jobs/ats-check';
import ResumeAuthenticity from './public/jobs/resume-authenticity';
import Register from './public/jobs/register';
import Developers from './public/jobs/developers';
import PrivacyPolicy from './public/legal/PrivacyPolicy';
import TermsAndConditions from './public/legal/TermsAndConditions';
import HomeRoute from './public/home/HomeRoute';
import RecommendationRequestPage from './public/recommendations/RecommendationRequestPage';
import Public from './public';
import React from 'react';
import ReactGA from 'react-ga4';
import ScrollToTop from '../pages/public/jobs/utils/ScrollToTop';
import { ThemeProvider } from '../theme/ThemeProvider';
ReactGA.initialize('G-6Q9ZTMVVV0', {
  testMode: false,
});

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Public />}>
            <Route path="/" element={<HomeRoute />} />
            <Route path="jobs" element={<Job />} />
            <Route path="/jobs/:job_Id" element={<Detail />} />
            <Route path="subscribe" element={<Subscribe />} />
            <Route path="improve-your-resume" element={<CVUpgrade />} />
            <Route path="ats-check" element={<AtsCheck />} />
            <Route
              path="resume-authenticity"
              element={<ResumeAuthenticity />}
            />
            <Route path="sign-up" element={<Register />} />
            <Route path="developers" element={<Developers />} />
            <Route path="privacy" element={<PrivacyPolicy />} />
            <Route path="terms" element={<TermsAndConditions />} />
            <Route
              path="recommendation-request/:token"
              element={<RecommendationRequestPage />}
            />
          </Route>

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
